import axios from 'axios';

async function shareWithStudentsRequest(institutionId, courseId, studentIds) {
  await axios.post(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/v2/Courses/${encodeURIComponent(courseId)}/Share`, {
    institutionID: institutionId,
    students: studentIds
  });
}

export { shareWithStudentsRequest };
//# sourceMappingURL=request.share-with-students.js.map
